import { render, staticRenderFns } from "./DocsExternalLink.vue?vue&type=template&id=ee1d6b68&scoped=true"
import script from "./DocsExternalLink.vue?vue&type=script&lang=js"
export * from "./DocsExternalLink.vue?vue&type=script&lang=js"
import style0 from "./DocsExternalLink.vue?vue&type=style&index=0&id=ee1d6b68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee1d6b68",
  null
  
)

export default component.exports